import { useEffect, useState, forwardRef } from "react";
import { useSelector } from "react-redux";
import clsx from "clsx";

import { Fade } from "@mui/material";

import { listenEventBroker } from "features/event-driver/broker/eventBrokerSlice";

import { categoryContentStyles } from "./CategoryContent.styles";

import THEME from "mui/theme-tokens.json";
const token_textsTimeout = THEME.transitions.fade.textsTimeout;

export const CategoryContent = forwardRef((props, ref) => {
  const classes = categoryContentStyles();

  const eventBroker = useSelector(listenEventBroker);

  const [textsTimeout] = useState(token_textsTimeout);
  const [visible, visibleSet] = useState(true);

  useEffect(() => {
    visibilityToogle();
  }, [eventBroker]);

  const visibilityToogle = () => {
    if (shouldHideThisItem()) {
      visibleSet(false);
      return;
    }
    visibleSet(true);
    return;
  };

  const shouldHideThisItem = () => {
    if (
      eventBroker.eventSource === "MenuItem" &&
      eventBroker.eventType === "hover" &&
      eventBroker.eventValue !== ""
    ) {
      return true;
    }
    return false;
  };

  return (
    <Fade timeout={textsTimeout} in={visible} ref={ref}>
      <div className={clsx(classes.category_content__root)}>
        {props.children}
      </div>
    </Fade>
  );
});
